import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
    {
        url_id: "/laporan/kelola-kartu-debit-visa",
        url_path: "/laporan/kelola-kartu-debit-visa",
    },
];
